import React from "react";
import { Row, Col, Space, Table, DatePicker, Input, } from "antd";

const ForU = ({
    refResult
}) => {

    const dataSource = [
        {
            key: '1',
            No: 12345,
            Date: '2022/05/21',
            Detail: {
                name: '南方，寂寞鐵道：我們在時光列車上相遇',
                author: '蕭菊貞',
                ISBN: '98763452545'
            },
            Amount: 4,
            State: '已完成',
        },
        {
            key: '2',
            No: 12346,
            Date: '2022/05/21',
            Detail: {
                name: '貓主子的科學：喵皇賣萌大小事',
                author: '史蒂芬‧蓋茲',
                ISBN: '5637354187'
            },
            Amount: 0,
            State: '處理中',
        },
    ];

    const columns = [
        {
            title: '推薦序號',
            dataIndex: 'No',
            key: 'No',
        },
        {
            title: '推薦日期',
            dataIndex: 'Date',
            key: 'Date',
        },
        {
            title: '書名/作者/ISBN',
            dataIndex: 'Detail',
            key: 'Detail',
            width: '60%',
            render: (e) => <div><a>{e.name}</a><br />{e.author}<br />{e.ISBN}</div>
        },
        {
            title: '館藏數量',
            dataIndex: 'Amount',
            key: 'Amount',
        },
        {
            title: '採購狀態',
            dataIndex: 'State',
            key: 'State',
            render: (text,a,b) => {
                // console.log(text,a,b)
                return (
                    <div style={{ backgroundColor: text== '處理中' ? 'lightgreen' : 'lightblue', padding: '9px 13px', borderRadius: '20px', width: 'fit-content' }} >{text}</div>
                )
            },
        },
    ];

    return (<>
        <Row gutter={[0, 20]}>
            <Col>
                <div style={{ backgroundColor: '#FFDAB9', width: 'fit-content', padding: '10px 15px', fontSize: '1.3em', borderRadius: '10px', boxShadow: '#e86813 1px 2px 0px' }}>
                    您推薦的清單
                </div>
            </Col>
            <Col span={24}>
                <Row align={'middle'} justify={'space-between'}>
                    <Col>
                        <Row gutter={[20, 10]}>
                            <Col>
                                <Space>
                                    <label>推薦時間</label>
                                    <DatePicker.RangePicker />
                                </Space>
                            </Col>
                            <Col>
                                <Space>
                                    <text>關鍵字搜尋</text>
                                    <Input />
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Row>

            </Col>
            <Col span={24}>
                <div style={{ backgroundColor: 'white', borderRadius: '5px', border: 'lightgrey solid 1px' }}>
                    <Table dataSource={dataSource} columns={columns} ref={refResult}
                        tableLayout="fixed"
                        scroll={{ x: 'max-content' }}
                    />
                </div>
            </Col>
        </Row>
    </>)
}

export default ForU